<template>
  <div class="mt-[10px] flex justify-between px-4" >
    <div class="text-[16px] font-sans font-[400] text-[#1F2D42] leading-[20px]">{{currentPage}} - <span>{{listLength}}</span> of <span>{{total}}</span> items</div>
    <div>
      <el-pagination
          :page-size="pageSize"
          :layout="layout"
          :total="total"
          :current-page="currentPage"
          @current-change="currentHandler"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "RaPagination",
  props: {
    total: Number,
    pageSize: {
      type: Number,
      default: 10,
    },
    layout: {
      type: String,
      default: "prev, pager, next, jumper"
    },
    currentPage: {
      type: Number,
      default: 1
    },
    listLength: Number
  },
  data() {
    return {

    }
  },
  methods: {
    currentHandler(page) {
      this.$emit('pageChange', page);
    }
  }
}
</script>
<style scoped>

</style>
